import React from 'react';
import CountUp from 'react-countup';
import './stat-bit.scss';

const StatBit = (props) => <div className="stat-bit">
  <div className="stat-bit-number">
    <span className="stat-bit-floater">
      {props.statNumber}
      {/* <CountUp separator="." start={0.0} decimalPlaces={1} end={props.statNumber}></CountUp> */}
    </span>
  </div>
  <div className="stat-bit-label">{props.statLabel}</div>
</div>
  ;

export default StatBit;
